<template>
    <span>{{formatAmount(this.value, this.precision)}}</span>
</template>

<script>
export default {
    name: "MoneyRender",
    props: {
        value:
        {
            type: Number|String,
            default: 0
        },
        precision:
        {
            type: Number,
            default: 2
        }
    },
    data()
    {
        return {}
    },
    methods:
    {
        // format(value)
        // {
            // return formatAmount(value, this.precision)
            // if(isNaN(value)) return '';
            // let precision = this.precision;
            // function formatInt(v)
            // {
            //     return `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g,function(s){
            //         return s+','
            //     })
            // }
            // function formatFloat(v)
            // {
            //     return v.toFixed(precision).substring(1);
            // }
            // return formatInt(Math.floor(value/1))+formatFloat(value%1);
        // },
        formatAmount(amount, precision = 2) {
            // 处理无效输入
            if (amount === null || amount === undefined || isNaN(Number(amount))) {
                return '0.00'.slice(0, 2 + precision);
            }

            // 将输入转换为数字
            let num = Number(amount);

            // 处理精度，四舍五入
            num = num.toFixed(precision);

            // 分割整数部分和小数部分
            const parts = num.split('.');
            const integerPart = parts[0];
            const decimalPart = parts[1] || '';

            // 整数部分添加千分号
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            // 组合结果
            return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render/MoneyRender.vue